import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
// import { useHistory } from "react-router";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { AbogadoService } from "../../_services/abogados.service";

const Abogado = ({ data, getAbogados, setEditAbogado, titulos }) => {
  const {
    register,
    handleSubmit,
    reset
  } = useForm();

  useEffect(() => {
    reset(data);

  }, [data]);

  const onSubmit = (newData) => {
    // return Swal.fire("Lo sentimos", "Esta funcionalidad aún  no esta implementada.", "info");
    Swal.fire({
      title: "¿Esta seguro de guardar los cambios?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        // newData.baja = newData.baja === "no" ? 0 : 1;
        let response = await AbogadoService.editAbogado(newData);
        if (response.status === 200) {
          getAbogados();
          Swal.fire(
            "Editado!",
            "Tus datos han sido editados.",
            "success"
          );
        }
        else {
          getAbogados();
          Swal.fire(
            "Error!",
            "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };

  const cancelEdit = () => {
    Swal.fire({
      title: "¿Esta seguro de deshacer los cambios?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        reset(data);
        Swal.fire(
          "Se han eliminado los cambios correctamente.",
          "",
          "success"
        );
      }
    });
  };

  return (
    <div className="abogado-container">
      <div className="abogado-container-form">
        <Form className="abogado-form" onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Apellidos</Form.Label>
              <Form.Control
                name="apellido"
                {...register("apellido")}
              />
            </Col>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Nombres</Form.Label>
              <Form.Control
                name="nombre"
                {...register("nombre")}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={6} md={6} className="mt-3">
              <Row>
                <Col className="col-4 pl-0">
                  <Form.Label className="text-uppercase mb-1">Documento</Form.Label>
                  <Form.Control
                    as="select"
                    defaultValue={1}
                    name="tipodni"
                    {...register("tipodni")}
                    readOnly
                  >
                    <option value={1}>DNI</option>
                  </Form.Control>
                </Col>
                <Col className="col-8 d-flex align-items-end">
                  <Form.Control
                    name="nrodni"
                    {...register("nrodni")}
                    readOnly
                  />
                </Col>
              </Row>
            </Col>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Dirección</Form.Label>
              <Form.Control
                name="direccion"
                {...register("direccion")}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Telefono</Form.Label>
              <Form.Control
                name="te"
                {...register("te")}
              />
            </Col>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Email</Form.Label>
              <Form.Control
                name="email"
                {...register("email")}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Matricula</Form.Label>
              <Form.Control
                name="matricula"
                {...register("matricula")}
              />
            </Col>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Cuit - Cuil</Form.Label>
              <Form.Control
                name="cuitcuil"
                {...register("cuitcuil")}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Titulo</Form.Label>
              <Form.Control
                as="select"
                name="titulo"
                {...register("titulo")}
              >
                <option value={""}>Seleccionar</option>
                {titulos?.length && titulos.map((e) => {
                  return (
                    <option key={e.id} value={e.id}>{e.titulo}</option>
                  );
                })}
              </Form.Control>
            </Col>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Baja</Form.Label>
              <Form.Control
                as="select"
                name="baja"
                {...register("baja")}
                defaultValue={0}
              >
                <option value={0}>No</option>
                <option value={1}>Si</option>
              </Form.Control>
            </Col>
          </Row>
          <Row>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Codigo Externo</Form.Label>
              <Form.Control
                name="codexterno"
                {...register("codexterno")}
                disabled
              />
            </Col>
          </Row>
          <Row >
            <Col xl={12} md={12} className="mt-3">
              <Form.Label className="text-uppercase mb-1">Horarios</Form.Label>
              <Form.Control
                as="textarea"
                name="horarios"
                {...register("horarios")}
              />
            </Col>
          </Row>

          <Row className="justify-content-center pt-4">
            <Button
              type="submit"
              style={{ maxWidth: 190 }}
              className="custom-button"
            >
              <span>Guardar cambios</span>
            </Button>
            <Button
              className="danger-button ml-3"
              style={{ maxWidth: 190 }}
              variant="danger"
              onClick={() => cancelEdit()}
            >
              <span>Deshacer cambios</span>
            </Button>
            {setEditAbogado && <Button className="ml-3" onClick={() => setEditAbogado({ show: false, data: null })}>Cancelar</Button>}

          </Row>
        </Form>
      </div>
    </div>
  );
};


export default Abogado;